export const TOUR_CURRENT = 'TOUR_CURRENT';

export const currentTour = (tourName, tour) => ({
    type:     TOUR_CURRENT,
    name:     tourName,
    tour: tour,
});
